import {createApp} from "vue";
import {createAuth0} from '@auth0/auth0-vue';
import {createPinia} from "pinia";
import App from "./App.vue";
import router from "./router";
import Cookies from 'js-cookie'

import axios from "axios";

import {setupCalendar, Calendar, DatePicker} from 'v-calendar';
import draggable from "vuedraggable";
import Multiselect from "vue-multiselect";
import i18n from "@/locales/i18n";
import Toast, {TYPE} from "vue-toastification";
import FloatingVue from 'floating-vue'
import VueDragReSizeRotate from "@gausszhou/vue3-drag-resize-rotate";
import dayjs from "dayjs";
import VueVirtualScroller from 'vue-virtual-scroller'

import "./assets/scss/theme.scss";
import "vue-toastification/dist/index.css";
import 'v-calendar/style.css';

// Import Bootstrap functionality
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import 'floating-vue/dist/style.css'

const app = createApp(App);

import "@/plugins/localeDate";
import "@/plugins/cityMap";
import globalHelpers from "./plugins/globalHelpers";
import SuccessIcon from './assets/toast/SuccessIcon.vue';
import ErrorIcon from './assets/toast/ErrorIcon.vue';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

app.config.globalProperties.$dayjs = dayjs;

// https://dummyjson.com/auth/
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.withCredentials = true;

app.use(globalHelpers); // Global Methods

const options = {
    toastDefaults: {
        [TYPE.SUCCESS]: {
            icon: SuccessIcon,
        },
        [TYPE.ERROR]: {
            icon: ErrorIcon,
        },
    },
};

const isOtpRoute = Cookies.get('is_otp_route') === 'true';

const auth0Domain = isOtpRoute
  ? process.env.VUE_APP_AUTH0_DOMAIN_OTP
  : process.env.VUE_APP_AUTH0_DOMAIN;

const auth0ClientId = isOtpRoute
  ? process.env.VUE_APP_AUTH0_CLIENT_ID_OTP
  : process.env.VUE_APP_AUTH0_CLIENT_ID;

app
    .use(i18n)
    .use(createPinia())
    .use(router)
    .use(createAuth0({
            domain: auth0Domain,
            clientId: auth0ClientId,
            useRefreshTokens: true,
            cacheLocation: 'localstorage',
            authorizationParams: {
                redirect_uri: process.env.VUE_APP_AUTH0_CALLBACK_URL
            }
        })
    )
    .use(setupCalendar, {})
    .use(Toast, {
        transition: "Vue-Toastification__fade",
        showCloseButtonOnHover: true,
        ...options
    })
    .use(VueDragReSizeRotate)
    .use(FloatingVue,
        {
            themes: {
                'nonius-tooltip': {
                    '$extend': 'tooltip',
                    distance: 10
                },
                'nonius-tooltip-sm': {
                    '$extend': 'nonius-tooltip',
                    distance: 10
                },
            },
        }
    )
    .use(VueVirtualScroller)
    .component("Icon", require('./components/IconComponent.vue').default)
    .component("SSelect", require('./components/dropdown/SingleSelect.vue').default)
    .component("MSelect", require('./components/dropdown/MultipleSelect.vue').default)
    .component("FSelect", require('./components/dropdown/MultipleFilter.vue').default)
    .component("Multiselect", Multiselect)
    .component("Draggable", draggable)
    .component('Calendar', Calendar)
    .component('DatePicker', DatePicker)
    .mount("#app");
